

import React, { useEffect } from 'react'
// import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Cookies } from 'react-cookie';


// const address_api = config[0].address;

function Logout() {
    const { setAuth } = useAuth();
    // const navigate = useNavigate()
    
    useEffect(() => {
        const cookies = new Cookies()
        // const config = { headers: {"Content-Type":"application/json"}, withCredentials: true};

        // axios.post(`${address_api}/users/logout`, config).then((res) => {
        //     console.log(res);
            setAuth(null)
            cookies.remove('refresh_token', { path: '/' })
            cookies.remove('access_token', { path: '/' })
            // removeCookie('refresh_teken');
            // removeCookie('access_token');
            // navigate('/')
        // })

    }, [setAuth]);

    return (
        <React.Fragment>
            <div>
                <br/>
                <br/>
                <br/>
                <h1>
                    شما از حساب خود خارج شده اید !!!
                </h1>
                <h2>
                    از این ما را انتخاب کرده ایده متشکریم ، ما نیز تمام سعی خود را برای رضایت شما خواهیم کرد.
                </h2>
                <br/>
                <br/>
                <br/>
            </div>
        </React.Fragment>
    );
}

export default Logout